import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CheckCircle2, Shield, Droplets, Flame, Recycle, ThermometerSnowflake, Factory, ChefHat, Sparkles } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const KleenCladDetail = () => {
  return (
    <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }}>
      <Header />
      <main style={{ paddingTop: '180px' }}>
        {/* Hero Section */}
        <section style={{
          background: 'var(--bg-primary)',
          padding: '80px 7.6923%',
          position: 'relative'
        }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <Link to="/nuvora" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              color: 'var(--brand-primary)',
              textDecoration: 'none',
              fontSize: '16px',
              marginBottom: '30px',
              transition: 'all 0.3s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateX(-5px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateX(0)'}
            >
              <ArrowLeft size={20} />
              Back to Nuvora
            </Link>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'center' }} className="detail-grid">
              <div>
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '20px', 
                  marginBottom: '30px' 
                }}>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_biz-innovations/artifacts/ny87boz7_generated-image%20%2811%29.png" 
                    alt="Nuvora" 
                    style={{ height: '80px', objectFit: 'contain' }}
                  />
                  <span style={{ color: 'var(--text-muted)', fontSize: '24px' }}>presents</span>
                </div>
                <h1 className="display-large" style={{ marginBottom: '20px' }}>
                  <span style={{ color: 'var(--brand-primary)' }}>KleenClad</span>
                </h1>
                <p className="heading-2" style={{ marginBottom: '20px', color: 'var(--text-muted)' }}>
                  Advanced Antimicrobial Cladding Solution
                </p>
                <p className="body-large" style={{ marginBottom: '30px' }}>
                  Hygienic wall protection tailored for commercial kitchens, designed to elevate food safety standards in high-traffic prep areas, processing zones, and washdown spaces.
                </p>
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                  <Link to="/#contact" className="btn-primary">
                    Get a Quote
                  </Link>
                  <Link to="/#contact" className="btn-secondary">
                    Request Demo
                  </Link>
                </div>
              </div>
              <div>
                <img 
                  src="https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800" 
                  alt="Commercial Kitchen" 
                  style={{ width: '100%', height: '450px', objectFit: 'cover', border: '1px solid var(--border-subtle)' }}
                />
              </div>
            </div>
          </div>
        </section>

        {/* Core Technology */}
        <section style={{ background: 'var(--bg-primary)', padding: '80px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{
              padding: '60px',
              background: 'rgba(0, 255, 209, 0.05)',
              border: '1px solid var(--brand-primary)'
            }}>
              <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h2 className="display-medium" style={{ marginBottom: '20px' }}>
                  Powered by <span style={{ color: 'var(--brand-primary)' }}>Polygiene Biomaster</span> Silver Ion Technology
                </h2>
              </div>
              <div style={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
                gap: '40px' 
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px'
                  }}>
                    <Shield size={40} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>99.99% Protection</h3>
                  <p className="body-medium">Inhibits bacterial growth with proven antimicrobial efficacy</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px'
                  }}>
                    <Sparkles size={40} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>24/7 Active Protection</h3>
                  <p className="body-medium">Continuous protection even on scratched surfaces</p>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px'
                  }}>
                    <CheckCircle2 size={40} color="var(--brand-primary)" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '12px' }}>Pathogen Defense</h3>
                  <p className="body-medium">Effective against Listeria, Salmonella, and E. coli</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Key Features */}
        <section style={{ background: 'var(--bg-primary)', padding: '80px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <h2 className="display-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
              Key <span style={{ color: 'var(--brand-primary)' }}>Features</span>
            </h2>

            <div style={{ display: 'grid', gap: '40px' }}>
              {/* Feature 1 */}
              <div style={{
                padding: '50px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
              >
                <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Droplets size={40} color="var(--brand-primary)" />
                  </div>
                  <div>
                    <h3 className="heading-1" style={{ marginBottom: '16px' }}>Non-porous & Stain-Resistant</h3>
                    <p className="body-medium" style={{ lineHeight: '1.8' }}>
                      Our advanced surface technology repels moisture and prevents biofilm formation, ensuring your walls stay hygienic and easy to clean at all times.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 2 */}
              <div style={{
                padding: '50px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
              >
                <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <ThermometerSnowflake size={40} color="var(--brand-primary)" />
                  </div>
                  <div>
                    <h3 className="heading-1" style={{ marginBottom: '16px' }}>IP66 Rated Durability</h3>
                    <p className="body-medium" style={{ lineHeight: '1.8' }}>
                      Built for humid and cold storage environments with impact-resistant panels that withstand the toughest commercial kitchen conditions.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 3 */}
              <div style={{
                padding: '50px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
              >
                <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <Factory size={40} color="var(--brand-primary)" />
                  </div>
                  <div>
                    <h3 className="heading-1" style={{ marginBottom: '16px' }}>Chemical Resistance</h3>
                    <p className="body-medium" style={{ lineHeight: '1.8' }}>
                      Engineered to withstand acids, alkalis, and industrial sanitizers—perfect for environments requiring rigorous cleaning protocols.
                    </p>
                  </div>
                </div>
              </div>

              {/* Feature 4 */}
              <div style={{
                padding: '50px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.3s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
              >
                <div style={{ display: 'flex', gap: '30px', alignItems: 'flex-start' }}>
                  <div style={{
                    width: '80px',
                    height: '80px',
                    background: 'rgba(0, 255, 209, 0.1)',
                    border: '1px solid var(--brand-primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}>
                    <ChefHat size={40} color="var(--brand-primary)" />
                  </div>
                  <div>
                    <h3 className="heading-1" style={{ marginBottom: '16px' }}>Easy Installation</h3>
                    <p className="body-medium" style={{ lineHeight: '1.8' }}>
                      Lightweight panels designed for quick and hassle-free installation, minimizing downtime for your commercial kitchen operations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ideal Applications */}
        <section style={{ background: 'var(--bg-primary)', padding: '80px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <h2 className="display-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
              Ideal <span style={{ color: 'var(--brand-primary)' }}>Applications</span>
            </h2>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
              gap: '40px'
            }}>
              <div style={{
                padding: '40px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.4s ease-in-out'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--brand-primary)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--border-subtle)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              >
                <ThermometerSnowflake size={48} color="var(--brand-primary)" style={{ marginBottom: '20px' }} />
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>Cold Storage & Refrigeration</h3>
                <p className="body-medium">
                  Prevents condensation and bacterial buildup, ensuring perishable goods remain safe and uncontaminated throughout storage.
                </p>
              </div>

              <div style={{
                padding: '40px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.4s ease-in-out'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--brand-primary)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--border-subtle)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              >
                <ChefHat size={48} color="var(--brand-primary)" style={{ marginBottom: '20px' }} />
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>Food Prep & Packaging</h3>
                <p className="body-medium">
                  Ultra-hygienic surfaces compliant with HACCP, FDA, and EU standards for the highest food safety requirements.
                </p>
              </div>

              <div style={{
                padding: '40px',
                background: 'rgba(255, 255, 255, 0.03)',
                border: '1px solid var(--border-subtle)',
                transition: 'all 0.4s ease-in-out'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = 'var(--brand-primary)';
                e.currentTarget.style.transform = 'translateY(-10px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = 'var(--border-subtle)';
                e.currentTarget.style.transform = 'translateY(0)';
              }}
              >
                <Droplets size={48} color="var(--brand-primary)" style={{ marginBottom: '20px' }} />
                <h3 className="heading-2" style={{ marginBottom: '16px' }}>Washdown Zones</h3>
                <p className="body-medium">
                  Designed to handle frequent cleaning without water ingress or dust accumulation, maintaining pristine hygiene standards.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Sustainability */}
        <section style={{ background: 'var(--bg-primary)', padding: '80px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <h2 className="display-medium" style={{ marginBottom: '60px', textAlign: 'center' }}>
              Sustainability <span style={{ color: 'var(--brand-primary)' }}>Benefits</span>
            </h2>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '30px'
            }}>
              <div style={{
                padding: '30px',
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid var(--brand-primary)',
                textAlign: 'center'
              }}>
                <Flame size={40} color="var(--brand-primary)" style={{ marginBottom: '16px' }} />
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>Fire Retardant</h3>
                <p className="body-small">EN13501 compliant for maximum safety</p>
              </div>

              <div style={{
                padding: '30px',
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid var(--brand-primary)',
                textAlign: 'center'
              }}>
                <Recycle size={40} color="var(--brand-primary)" style={{ marginBottom: '16px' }} />
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>100% Recyclable</h3>
                <p className="body-small">Eco-friendly end-of-life disposal</p>
              </div>

              <div style={{
                padding: '30px',
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid var(--brand-primary)',
                textAlign: 'center'
              }}>
                <CheckCircle2 size={40} color="var(--brand-primary)" style={{ marginBottom: '16px' }} />
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>BREEAM & LEED</h3>
                <p className="body-small">Supports green building certifications</p>
              </div>

              <div style={{
                padding: '30px',
                background: 'rgba(0, 255, 209, 0.05)',
                border: '1px solid var(--brand-primary)',
                textAlign: 'center'
              }}>
                <Sparkles size={40} color="var(--brand-primary)" style={{ marginBottom: '16px' }} />
                <h3 className="heading-2" style={{ marginBottom: '12px' }}>VOC-Free</h3>
                <p className="body-small">K-Bio Weld trims & contaminant-free joints</p>
              </div>
            </div>
          </div>
        </section>

        {/* Usage Note */}
        <section style={{ background: 'var(--bg-primary)', padding: '40px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{
              padding: '30px 40px',
              background: 'rgba(255, 200, 0, 0.1)',
              border: '1px solid rgba(255, 200, 0, 0.5)',
              display: 'flex',
              alignItems: 'center',
              gap: '20px'
            }}>
              <span style={{ fontSize: '24px' }}>⚠️</span>
              <div>
                <p className="body-medium" style={{ color: 'var(--text-primary)' }}>
                  <strong>Usage Note:</strong> KleenClad is suitable for service temperatures up to 50°C. Avoid direct heat sources like ovens.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section style={{ background: 'var(--bg-primary)', padding: '80px 7.6923%' }}>
          <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{
              padding: '80px 60px',
              background: 'rgba(0, 255, 209, 0.05)',
              border: '2px solid var(--brand-primary)',
              textAlign: 'center'
            }}>
              <h2 className="display-medium" style={{ marginBottom: '20px' }}>
                Transform Your <span style={{ color: 'var(--brand-primary)' }}>Commercial Kitchen</span>
              </h2>
              <p className="body-large" style={{ marginBottom: '20px', maxWidth: '800px', margin: '0 auto 20px' }}>
                Contact Nuvora at VDM Business Innovations for tailored installations across India.
              </p>
              <p className="body-medium" style={{ marginBottom: '40px', color: 'var(--text-muted)' }}>
                Elevate your food safety standards with KleenClad's advanced antimicrobial protection.
              </p>
              <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <Link to="/#contact" className="btn-primary">
                  Request a Consultation
                </Link>
                <Link to="/nuvora" className="btn-secondary">
                  Explore Nuvora Products
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <style>{`
        @media (max-width: 768px) {
          .detail-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
};

export default KleenCladDetail;
